
import { Grid2X2, Tag, Search } from "lucide-react";

const FeaturesSection = () => {
  return (
    <section className="py-20 px-6 bg-clustr-background">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Your digital collection, intelligently organized
          </h2>
          <p className="text-lg text-clustr-darkGray max-w-3xl mx-auto">
            Clustr transforms scattered bookmarks into a visual library that grows with your creative practice. Save anything that catches your eye and always find it when you need it.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-clustr-lightGray hover:shadow-md transition-all duration-300 animate-fade-up">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              <Grid2X2 className="h-6 w-6 text-clustr-blue" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Organized Collections</h3>
            <p className="text-clustr-darkGray">
              Keep related content in dedicated spaces for quick access and clear organization.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-clustr-lightGray hover:shadow-md transition-all duration-300 animate-fade-up" style={{ animationDelay: "100ms" }}>
            <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4">
              <Tag className="h-6 w-6 text-clustr-magenta" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Smart Tagging</h3>
            <p className="text-clustr-darkGray">
              Create flexible connections between content with tags that work across your entire library.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-clustr-lightGray hover:shadow-md transition-all duration-300 animate-fade-up" style={{ animationDelay: "200ms" }}>
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
              <Search className="h-6 w-6 text-purple-600" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Intelligent Search</h3>
            <p className="text-clustr-darkGray">
              Find exactly what you're looking for with AI search that understands context and relationships.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
